import React, { useState, useEffect, useRef } from "react"
import { Row, Col, Button, Label, Input, Container } from "reactstrap"
import Modal from "react-bootstrap/Modal"
import { withRouter } from "react-router-dom"
// import Select from "react-select"
// import SimpleReactValidator from "simple-react-validator"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import { connect, useSelector, useDispatch } from "react-redux"
import SimpleReactValidator from "simple-react-validator"

import * as clientAction from "../../../store/Y2xpZW50/actions"

const ClientQuestionsList = (props) => {
  const { dispatch, clientId, checked } = props

  useEffect(() => {
    if (props.moduleMode != "Data" && questionModal == true) {
      dispatch(clientAction.loadClientQuestionList({ module: "sales" }))
    }
  }, [])
  //Modal
  const [questionModal, setQuestionModal] = useState(false)
  const handleQuestionModal = () => setQuestionModal(false)

  const clientUpdate = useSelector((specificState) => specificState.client)

  const { questions_list, client_questions_list } = clientUpdate

  const specificDispatch = useDispatch()

  console.log(questions_list, "questions list from client api")
  console.log(client_questions_list, "client_questions_list from client api")
  console.log(clientId, "clientId from client api")

  // const [chooseOptions, setChooseOptions] = useState([])
  const [optionsChecked, setOptionsChecked] = useState([])
  //QUESTIONS ON CHANGES
  const [questionDetails, setQuestionsDetails] = useState([])

  const [finalSubmit, setFinalSubmit] = useState(false)

  const handleChoose = async (e, index, id, name, chooseData) => {
    let isChecked = e.target.checked

    console.log("chooseData handle isChecked ", isChecked)

    let optionsCheckedArray = optionsChecked

    if (isChecked && !optionsCheckedArray.includes(chooseData.option)) {
      optionsCheckedArray.push(chooseData.option)
    } else {
      optionsCheckedArray.splice(
        optionsCheckedArray.indexOf(chooseData.option),
        1
      )
    }

    setOptionsChecked(optionsCheckedArray)

    console.log("chooseData handle incomeing ", optionsCheckedArray)

    var choose = questionDetails
    console.log(index)
    e = e.target.value
    console.log(e, "event from change service")
    console.log(index)
    choose
      .filter((someobject) => someobject._id == id)

      .forEach((someobject) => {
        someobject[name] = e
        if (name == "choose") {
          someobject["choose"] = chooseData.option
        }
      })

    console.log("chooseData handle", choose)
    setQuestionsDetails(choose)
  }
  const handleDescription = async (e, index, id, name) => {
    var description = questionDetails
    console.log(index)
    e = e.target.value
    console.log(e, "event from change service")
    console.log(index)
    // oddServiceData[index].quantity = e
    // oddServiceData[index].amount = oddServiceData[index].actualAmount
    description
      .filter((someobject) => someobject._id == id)

      .forEach((someobject) => {
        someobject[name] = e
        if (name == "description") {
          someobject["description"] = e
        }
      })
    setQuestionsDetails(description)
  }

  //Data Table
  const questionsDataTable =
    questions_list && questions_list.length > 0
      ? questions_list.map((data) => {
          return {
            _id: data._id,
            module: data.module,
            modeType: data.modeType,
            mandatory: data.mandatory,
            question: data.question,
            choose: data.choose,
            type: data.type,
          }
        })
      : []

  useEffect(() => {
    if (questions_list && questions_list.length > 0) {
      setQuestionsDetails(questionsDataTable)
    }
  }, [questions_list])

  console.log(questionsDataTable, "questionsDataTable")
  console.log(questionDetails, "questionDetails")
  // console.log(chooseOptions, "chooseOptions")
  //Validator
  const simpleValidator = useRef(new SimpleReactValidator())
  // const simpleValidator = useRef(new SimpleReactValidator())
  const [forceUpdate, setForceUpdate] = useState(false)

  const handleQuestions = (e) => {
    e.preventDefault()
    const questionSubmit = !isEmpty(questionDetails)
      ? questionDetails.map((data) => {
          if (data.type === "description") {
            console.log(data.description, "descriptions")
            return {
              questionId: data._id,
              mode: "single",
              answer: data.description,
            }
          } else if (data.type === "choose") {
            console.log("datachoosedata", data.choose)
            return {
              questionId: data._id,
              mode: "multiple",
              answer: optionsChecked.toString(""),
            }
          }
        })
      : []

    if (simpleValidator.current.allValid()) {
      const questionsList = {
        clientId: clientId,
        question: questionSubmit.filter((el) => {
          return el != null
        }),
      }
      specificDispatch(clientAction.createClientQuestionList(questionsList))
      setTimeout(() => {
        specificDispatch(clientAction.loadClientDetailsQuestionsList(clientId))
        dispatch(clientAction.loadClientQuestionList({ module: "sales" }))
      }, 2000)
      handleQuestionModal()
      console.log(questionsList, "questionsList")
      setFinalSubmit(true)
    } else {
      simpleValidator.current.showMessages()
      setForceUpdate(true)
      setQuestionModal(true)
      console.log(forceUpdate)
      return false
    }
  }

  useEffect(() => {
    if (questionModal === true) {
      specificDispatch(clientAction.loadClientDetailsQuestionsList(clientId))
    }
  }, [questionModal])

  return (
    <React.Fragment>
      <Container fluid>
        <Col md="12" xl="12" lg="12" sm="12" xs="12" className="mt-2">
          <Row
            className={
              checked
                ? "question-card-checked-content"
                : "question-card-content"
            }
          >
            <Col>
              <h1 className="question-head">Questions List</h1>
            </Col>
            <Col>
              <div
                className={
                  checked
                    ? "question-modal-checked-button"
                    : "question-modal-button"
                }
                onClick={() => setQuestionModal(true)}
              >
                Questions
              </div>
            </Col>
          </Row>
          {questionModal && (
            <Modal show={questionModal} onHide={handleQuestionModal} size="lg">
              <Modal.Header
                style={{
                  backgroundColor: "#e40d8c",
                  color: "#ffffff",
                  fontWeight: "600",
                  fontSize: "16px",
                }}
              >
                Questions List
              </Modal.Header>
              <Modal.Body>
                {questionDetails.map((data, index) => {
                  const choose = data.choose.length > 0 ? data.choose : []
                  const chooseDetails = !isEmpty(choose)
                    ? choose.filter((el) => {
                        return el != null
                      })
                    : []
                  return (
                    <div key={data._id}>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div className="d-flex flex-row">
                          <p style={{ fontSize: "12px", fontWeight: 550 }}>
                            {index + 1} {"."}
                          </p>
                          <Label className="event-label">
                            {data.question}
                            {/* {data.mandatory === 1 ? (
                              <>
                                <span className="event-required">*</span>
                              </>
                            ) : (
                              ""
                            )} */}
                          </Label>
                        </div>
                        {data.type === "choose" ? (
                          <>
                            <>
                              {!isEmpty(chooseDetails)
                                ? chooseDetails.map((chooseData, index) => {
                                    console.log(chooseData, "chooseData")
                                    return (
                                      <div
                                        key={index}
                                        className="d-flex flex-row"
                                      >
                                        {finalSubmit ||
                                        client_questions_list.length > 0 ? (
                                          client_questions_list &&
                                          client_questions_list.map((desc) => {
                                            if (
                                              desc.mode === "multiple" &&
                                              desc.questionId === data._id
                                            )
                                              return (
                                                <div key={0}>{desc.answer}</div>
                                              )
                                          })
                                        ) : (
                                          <>
                                            <Input
                                              type="checkbox"
                                              name="choose"
                                              value={data.choose}
                                              onChange={(e) =>
                                                handleChoose(
                                                  e,
                                                  index,
                                                  data._id,
                                                  "choose",
                                                  chooseData
                                                )
                                              }
                                            />{" "}
                                            <Label className="mx-2">
                                              {chooseData.option}
                                            </Label>
                                          </>
                                        )}

                                        {/* {data.mandatory === 1 ? (
                                      <>
                                        {simpleValidator.current.message(
                                          "choose",
                                          data.choose,
                                          "required"
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )} */}
                                      </div>
                                    )
                                  })
                                : []}
                            </>
                          </>
                        ) : (
                          []
                        )}
                        {data.type === "description" ? (
                          <>
                            {finalSubmit || client_questions_list.length > 0 ? (
                              client_questions_list &&
                              client_questions_list.map((desc, index) => {
                                if (
                                  desc.mode === "single" &&
                                  desc.questionId === data._id
                                )
                                  return <div key={index}>{desc.answer}</div>
                              })
                            ) : (
                              <>
                                <textarea
                                  type="text"
                                  name="description"
                                  placeholder="Enter Description"
                                  value={data.description}
                                  onChange={(e) =>
                                    handleDescription(
                                      e,
                                      index,
                                      data._id,
                                      "description"
                                    )
                                  }
                                  className="question-crowd-textarea"
                                />
                              </>
                            )}

                            {/* {data.mandatory === 1 &&
                            isEmpty(data.description) ? (
                              <>
                                {simpleValidator.current.message(
                                  "description",
                                  data.description,
                                  "required"
                                )}
                              </>
                            ) : (
                              ""
                            )} */}
                          </>
                        ) : (
                          ""
                        )}
                        {/* {finalSubmit ? 
                        
                       : ""} */}
                      </Col>
                      {/* {data.type === "choose" && data.mandatory === 1 ? (
                        <>
                          {simpleValidator.current.message(
                            "description",
                            data.choose,
                            "required"
                          )}
                        </>
                      ) : data.type === "description" &&
                        data.mandatory === 1 ? (
                        <>
                          {simpleValidator.current.message(
                            "description",
                            data.description,
                            "required"
                          )}
                        </>
                      ) : (
                        ""
                      )} */}
                    </div>
                  )
                })}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleQuestionModal}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-success"
                  onClick={(e) => {
                    handleQuestions(e)
                  }}
                >
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </Col>
      </Container>
    </React.Fragment>
  )
}

ClientQuestionsList.propTypes = {
  dispatch: PropTypes.func,
  questions_list: PropTypes.array,
  employee_list: PropTypes.array,
  clientId: PropTypes.string,
  clientProfile: PropTypes.array,
  recordsMetaData: PropTypes.object,
  salesRecordsMetaData: PropTypes.object,
  moduleMode: PropTypes.any,
  records: PropTypes.array,
  error: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
  checked: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
}

const mapStateToProps = (state) => ({
  questions_list: state.client.questions_list,
  employee_list: state.client.employee_list,
})

/**
 *
 * @param {function} dispatch
 * @returns
 */
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ClientQuestionsList)
)
